<template>
  <div class="panel-body">
    <div id="shipping-status-inquiry" class="flexbox gap-15 flex-content-start" style="flex-wrap: nowrap;">
      <div class="filter">
        <form autocomplete="off"  class="w-210">
          <span class="control-label label-normal">区分</span><br>
          <div class="pd-l-10 pd-t-10">
            <div v-for="item in shippingKbnOption" :key="item.value" class="form-check">
              <input type="checkbox" name="shippingKbn" :value="item.value" class="form-check-input" :id="'shippingKbn-' + item.value"
                v-model="filter.shippingKbn">
              <label class="form-check-label" :for="'shippingKbn-' + item.value">{{ item.label }}</label>
            </div>
          </div>
          <div class="form-group">
            <label class="control-label label-normal">出荷管理番号</label>
            <input type="text" class="form-control" v-model.trim="filter.shippingNo">
          </div>
          <div class="form-group">
            <label class="control-label label-normal">出荷ID</label>
            <input type="text" class="form-control" v-model.trim="filter.shippingId">
          </div>
          <div class="form-group">
            <label class="control-label label-normal">ASIN</label>
            <input type="text" class="form-control" v-model.trim="filter.asin">
          </div>
          <div class="form-group">
            <label class="control-label label-normal">出荷依頼日</label>
            <date-picker
              v-model="filter.createDate"
              placeholder=""
              ref="datepickerStart"
              format="YYYY/MM/DD"
              :input-attr="{id: 'create-date'}"
              :lang="lang"
            ></date-picker>
          </div>
          <span class="control-label label-normal">出荷ステータス</span><br>
          <div class="pd-l-10 pd-t-10">
            <div v-for="item in wareHouseStatusOption" :key="item" class="form-check">
              <input type="checkbox" name="warehouseStatus" :value="item" class="form-check-input" :id="'warehouseStatus-' + item"
                v-model="filter.warehouseStatus">
              <label class="form-check-label" :for="'warehouseStatus-' + item">{{ item }}</label>
            </div>
          </div>
          <div class="flexbox gap-10 mr-t-15">
            <button type="button" class="btn btn-primary w-100" @click="filterShipping">検索</button>
            <button type="button" class="btn w-100" @click="clearFilter">クリア</button>
          </div>
        </form>
      </div>
      <div class="">
        <div class="flexbox justify-between count">
          <span class="count">{{ displayData.length }} 件</span>
          <span class="count">(注) Amazon倉庫への出荷について、出荷登録直後は明細が表示されません。しばらくたってからご確認ください。</span>
        </div>
        <div class="table-outter">
          <div class="table-header">
            <table class="">
              <thead>
                <tr>
                  <th class="w-120"></th>
                  <th class="text-left w-180">区分</th>
                  <th class="text-left w-250">出荷管理番号（出荷ID）</th>
                  <th class="text-left w-300">出荷名（依頼番号）</th>
                  <th class="text-left w-160">出荷依頼日（出荷日）</th>
                  <th class="text-left w-150">出荷ステータス</th>
                  <th class="w-270"></th>
                </tr>
              </thead>
            </table>
          </div>
          <div v-if="displayData.length > 0" v-for="(item, index) in displayData" :key="index" class="table-group mr-t-15" :id="'table-group-' + item.shippingId + '-' + item.shippingNo">
            <table style="table-layout: fixed;">
              <tbody>
                <tr>
                  <td class="text-center w-120">
                    <button class="btn btn-expand w-100" data-toggle="collapse" :id="'btn-expand-' + item.shippingId + '-' + item.shippingNo" :data-target="'#' + item.shippingId + '-' + item.shippingNo" @click="handleExpand(item.shippingId, item.shippingNo)" :disabled="item.shippingGoods.length === 0">
                      <i class="fa fa-plus" aria-hidden="true"></i> 開く
                    </button>
                    <button class="btn btn-collapse w-100 hidden" data-toggle="collapse" :id="'btn-collapse-' + item.shippingId + '-' + item.shippingNo" :data-target="'#' + item.shippingId + '-' + item.shippingNo" @click="handleCollapse(item.shippingId, item.shippingNo)">
                      <i class="fa fa-minus" aria-hidden="true"></i> 閉じる
                    </button>
                  </td>
                  <td class="text-left w-180">
                    {{ getShippingKbnText(item.shippingKbn) }}
                  </td>
                  <td class="text-left w-250">
                    {{ item.shippingNo }} <br>
                    ({{ item.shippingId }})
                  </td>
                  <td class="text-left w-300" style="word-break: break-all;">
                    {{ item.shippingName }} <br>
                    {{ item.requestNo && "(" + item.requestNo + ")" }}
                  </td>
                  <td class="text-left w-160">
                    {{ formatDate(item.createDate) }} <br>
                    {{ item.shippingDate && '(' + formatDate(item.shippingDate) + ')' }}
                  </td>
                  <td class="text-size-16 text-left w-150">
                    <span :class="getStatusTextClass(item.status)">
                      {{ item.status }}
                    </span>
                    <div v-if="checkStatus(item.status)" class="shipping-status" :class="getStatusClass(item.status)"></div>
                  </td>
                  <td class="text-left w-270">
                    <div class="flexbox gap-5 justify-right">
                      <button type="button" class="btn btn-primary w-80 check-maintenace" @click="openModalDeliveyInfo(item)">出荷情報</button>
                      <button type="button" class="btn btn-primary w-55 check-maintenace" :class="item.disableEdit ? 'disabled' : ''" :disabled="item.disableEdit" @click="handleEdit(item)">編集</button>
                      <button type="button" class="btn btn-danger w-55 bg-white text-danger check-maintenace" :class="item.disableDelete ? 'disabled' : ''" :disabled="item.disableDelete" @click="openConfirmDeleteModal(item)">削除</button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-if="item.shippingGoods.length" :id="item.shippingId + '-' + item.shippingNo" class="collapse table-item" style="background-color: #fff; margin: 0 10px 10px 10px;">
              <table class="full-width" style="table-layout: fixed;">
                <thead>
                  <tr>
                    <th class="text-center w-150">出荷する商品</th>
                    <th></th>
                    <th class="text-right w-150">出荷予定数</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="product in item.shippingGoods" :key="product.itemId">
                    <td class="text-center w-150">
                        <div v-if="product.image" class="box-selected-product-image w-50">
                            <img loading="lazy" :src="product.image"
                                alt="" class="selected-product-image img-responsive">
                        </div>
                        <div v-if="product.status_str" class="box-delivery-judgment-status" :class="getJudgmentStatusClass(product.status_str)">{{ product.status_str }}</div>
                    </td>
                    <td class="text-left">
                      <span>{{ product.itemName }}</span>
                      <br>
                      <span><b>ASIN：</b>{{ product.asin }} / <b>SKU：</b>{{ product.sku }}</span>
                      <br>
                      <span><b>商品ID：</b>{{ product.itemId }} / <b>商品ラベル：</b>{{ product.fnsku }}</span>
                    </td>
                    <td class="text-right text-size-20 font-bold">
                      <span>{{ formatNumber(product.quantity) }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-if="displayData.length === 0" class="table-group text-center text-danger no-data">
              データが見つかりません。
          </div>
        </div>
      </div>
    </div>
    <modal-confirm-delete
      v-if="openModalConfirmDelete"
      @confirm="handleDelete()"
      @close="closeConfirmDeleteModal()"
    />
    <shipping-info-modal
      v-if="openShippingInfoModal"
      :selectShipping="selectItem"
      @close="closeModalShippingInfo"
    />
  </div>
</template>

<script>
import Util from '@/common/utility'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import WarehouseAcrossService from '@/services/warehouseacrossservice'
import ShippingInfo from './components/ShippingInfo'
import ModalConfirmDelete from '@/components/ModalDeleteAlert'
import ShippingInfoModal from '@/view/warehouseAcross/components/ShippingInfoModal'
import { mapGetters } from 'vuex'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  components: {
    DatePicker,
    ShippingInfo,
    ModalConfirmDelete,
    ShippingInfoModal
  },
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      shippingKbnOption: [
        {
          value: '01',
          label: 'Amazon倉庫へ出荷'
        },
        {
          value: '02',
          label: 'マルチチャネル出荷'
        },
        {
          value: '03',
          label: 'ヤマト運輸倉庫へ出荷'
        }
      ],
      wareHouseStatusOption: ['出荷待ち', '出荷準備中', '出荷済', '登録処理エラー'],
      filter: {
        shippingKbn: ['01', '02', '03'],
        shippingNo: '',
        shippingId: '',
        asin: '',
        createDate: '',
        warehouseStatus: ['出荷待ち', '出荷準備中', '出荷済', '登録処理エラー']
      },
      lang: {
        days: ['日', '月', '火', '水', '木', '金', '土'],
        months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        pickers: ['1週間後', '1ヶ月後', '1週間前', '1ヶ月前'],
        placeholder: {
          date: '日付を選択',
          dateRange: '期間を選択'
        }
      },
      defaultData: [],
      displayData: [],
      openModalConfirmDelete: false,
      openShippingInfoModal: false,
      selectItem: {}
    }
  },
  created () {
    this.getShippingList()
  },
  computed: {
    ...mapGetters({
      userInfo: 'getUser'
    })
  },
  methods: {
    async getShippingList () {
      this.loader = this.$loading.show()
      await WarehouseAcrossService.getShippingList()
        .then((response) => {
          this.defaultData = this.displayData = response.data
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    formatDate (value) {
      return value ? moment(value).format('YYYY/MM/DD') : ''
    },
    handleExpand (id, no) {
      $('#table-group-' + id + '-' + no).addClass('expand')
      $('#btn-expand-' + id + '-' + no).addClass('hidden')
      $('#btn-collapse-' + id + '-' + no).removeClass('hidden')
    },
    handleCollapse (id, no) {
      $('#table-group-' + id + '-' + no).removeClass('expand')
      $('#btn-expand-' + id + '-' + no).removeClass('hidden')
      $('#btn-collapse-' + id + '-' + no).addClass('hidden')
    },
    openModalDeliveyInfo (item) {
      this.selectItem = item
      this.openShippingInfoModal = true
      let logParams = {
        name: eventCode.warehouse_across.shipping_tab.list.click_show_shipping_info_btn,
        properties: {
          shippingNo: item.shippingNo,
          shippingId: item.shippingId
        }
      }
      EventService.postTrackLog(logParams)
    },
    closeModalShippingInfo () {
      this.openShippingInfoModal = false
      $('#shipping-info-modal').modal('hide')
    },
    openConfirmDeleteModal (item) {
      if (item.disableDelete) {
        return false
      }
      this.selectItem = item
      this.openModalConfirmDelete = true
    },
    closeConfirmDeleteModal () {
      this.openModalConfirmDelete = false
      $('#delete-alert').modal('hide')
    },
    filterShipping () {
      let logParams = {
        name: eventCode.warehouse_across.shipping_tab.list.click_search_btn,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      this.loader = this.$loading.show()
      setTimeout(() => {
        var shippingKbn = this.filter.shippingKbn
        var shippingNo = this.filter.shippingNo
        var shippingId = this.filter.shippingId
        var asin = this.filter.asin
        var createDate = this.filter.createDate
        var warehouseStatus = this.filter.warehouseStatus
        let defaultData = [...this.defaultData]

        if (shippingKbn.length) {
          defaultData = defaultData.filter(item => {
            return (item.shippingKbn && shippingKbn.includes(item.shippingKbn))
          })
        }

        if (shippingNo) {
          defaultData = defaultData.filter(item => {
            return (item.shippingNo && item.shippingNo.toLowerCase().includes(shippingNo.toLowerCase()))
          })
        }

        if (shippingId) {
          defaultData = defaultData.filter(item => {
            return (item.shippingId && item.shippingId.toLowerCase().includes(shippingId.toLowerCase()))
          })
        }

        if (asin) {
          defaultData = defaultData.filter(item => {
            return (item.shippingGoods.length && item.shippingGoods.find(product => { return product.asin.toLowerCase().includes(asin.toLowerCase()) }))
          })
        }

        if (createDate) {
          defaultData = defaultData.filter(item => {
            return (item.createDate && this.formatDate(item.createDate) === this.formatDate(createDate))
          })
        }

        if (warehouseStatus.length) {
          defaultData = defaultData.filter(item => {
            return (item.status && warehouseStatus.includes(item.status))
          })
        }
        this.displayData = defaultData
        this.loader && this.loader.hide()
      }, 500)
    },
    clearFilter () {
      this.filter = {
        shippingKbn: ['01', '02', '03'],
        shippingId: '',
        asin: '',
        createDate: '',
        warehouseStatus: ['出荷待ち', '出荷準備中', '出荷済', '登録処理エラー']
      }
      this.displayData = [...this.defaultData]
    },
    getShippingKbnText (shippingKbn) {
      let shippingKbnItem = this.shippingKbnOption.find(item => item.value === shippingKbn)
      return shippingKbnItem.label
    },
    getStatusTextClass (status) {
      if (status === '登録処理エラー') {
        return 'register-processing-error'
      }
      if (status === '登録処理中') {
        return 'register-processing-inprogress'
      }

      return ''
    },
    checkStatus (status) {
      const showStatus = ['出荷待ち', '出荷準備中', '出荷済']
      return showStatus.includes(status)
    },
    getStatusClass (status) {
      if (status === '出荷待ち') {
        return 'awaiting-shipping'
      }
      if (status === '出荷準備中') {
        return 'preparing-to-ship'
      }
      if (status === '出荷済') {
        return 'shipped'
      }
    },
    getJudgmentStatusClass (status) {
      let statusStop = ['停止中', '削除済']
      let statusSuccess = ['出品中']
      let statusWarning = ['未審査', '審査中']
      let statusDanger = ['出品NG', '審査NG']
      if (!status) {
        return ''
      }
      if (statusSuccess.includes(status)) {
        return 'judgment-status-success'
      }
      if (statusWarning.includes(status)) {
        return 'judgment-status-warning'
      }
      if (statusDanger.includes(status)) {
        return 'judgment-status-danger'
      }
      if (statusStop.includes(status)) {
        return 'judgment-status-stop'
      }
    },
    formatNumber (number) {
      return Util.formatMoney(number)
    },
    handleEdit (item) {
      if (item.disableEdit || item.shippingKbn === '01') {
        return false
      }

      let logParams = {
        name: eventCode.warehouse_across.shipping_tab.list.click_edit_btn,
        properties: {
          shippingNo: item.shippingNo,
          shippingId: item.shippingId
        }
      }
      EventService.postTrackLog(logParams)

      let subTab = item.shippingKbn === '02' ? 'edit-multi-channel' : 'edit-yamato-shipping'
      this.$router.push({
        name: 'Warehouse across',
        params: {
          tab: 'shipping',
          subTab: subTab
        },
        query: {
          shippingNo: item.shippingNo,
          shippingId: item.shippingId
        }
      })
    },
    handleDelete () {
      if (this.selectItem.disableDelete || this.selectItem.shippingKbn === '01') {
        this.closeConfirmDeleteModal()
        return false
      }
      if (this.selectItem.shippingKbn === '02') {
        this.deleteShippingMultichannel()
      }

      if (this.selectItem.shippingKbn === '03') {
        this.deleteShippingYamato()
      }
    },
    async deleteShippingMultichannel () {
      this.loader = this.$loading.show()
      let params = {
        shippingNo: this.selectItem.shippingNo,
        shippingId: this.selectItem.shippingId
      }

      let logParams = {
        name: eventCode.warehouse_across.shipping_tab.list.click_delete_btn,
        properties: params
      }
      EventService.postTrackLog(logParams)

      await WarehouseAcrossService.deleteShippingMultichannel(params)
        .then((response) => {
          if (response.data.shippingId) {
            this.displayData = this.displayData.filter(item => {
              return item.shippingNo !== response.data.shippingNo
            })
          }
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
          this.closeConfirmDeleteModal()
        })
    },
    async deleteShippingYamato () {
      this.loader = this.$loading.show()
      let params = {
        shippingNo: this.selectItem.shippingNo,
        shippingId: this.selectItem.shippingId
      }

      let logParams = {
        name: eventCode.warehouse_across.shipping_tab.list.click_delete_btn,
        properties: params
      }
      EventService.postTrackLog(logParams)

      await WarehouseAcrossService.deleteShippingYamato(params)
        .then((response) => {
          if (response.data.shippingId) {
            this.displayData = this.displayData.filter(item => {
              return item.shippingNo !== response.data.shippingNo
            })
          }
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
          this.closeConfirmDeleteModal()
        })
    }
  },
  mounted () {
    let logParams = {
      name: eventCode.warehouse_across.shipping_tab.list.show,
      properties: {}
    }
    EventService.postTrackLog(logParams)
  },
  watch: {
  }
}
</script>
<style scoped>
.judgment-status-stop {
  background-color: #a6a6a6;
  color: #f2f2f2;
}
.judgment-status-danger {
  background-color: #c00000;
  color: #fff;
}
.panel-body {
  padding: 10px 0;
}
.control-label {
  color: #595959;
}
.filter {
  padding: 10px;
  background-color: #fff;
  border: 1px solid #ccc;
  height: auto;
  box-sizing: content-box;
}
.form-check-label {
  padding-left: 5px;
  font-weight: unset;
}
.table-outter {
  margin-top: 5px;
  overflow-x: auto;
  overflow-y: auto;
  width: 1440px;
}
.table-header {
  table-layout: fixed;
  border: 1px solid #ccc;
  position: sticky;
  top: 0;
  z-index: 1;
  background: #deebf7;
}
.table-header th {
  padding: 5px 10px;
  margin: 0 10px;
  color: #595959;
  background: #deebf7;
}

.table-header td {
  padding: 5px;
  height: 50px;
}
.text-danger {
  font-weight: unset;
}
.btn.disabled {
  background-color: #efefef;
  color: #000;
  border: 1px solid #ccc;
}
.table-item th{
  background-color: #fff;
  color: #000;
  font-weight: bold;
  border: none;
  border-bottom: 2px solid #008cc6;
  padding: 0 5px;
  z-index: -1;
}
.table-item td {
  border-bottom: 1px solid #ccc;
}
.table-group {
  background-color: #fff;
  border: 1px solid #ccc;
  vertical-align: middle;
}
.table-group td {
  padding: 5px 10px;
  height: 50px;
}
.table-group > tr.collapse td {
  background-color: red;
}
.table-group.expand {
  background-color: #deebf7;
}
.btn-expand {
  color: #008cc6;
  border: 1px solid #008cc6;
  background-color: #fff;
}
.btn-collapse {
  color: #000;
  background-color: #bfbfbf;
  border: 1px solid #ccc;
}
.box-selected-product-image {
  margin: 0 auto;
}
.shipping-status {
  width: 80px;
  height: 10px;
  border-radius: 4px;
  border: 1px solid #bfbfbf;
}
.awaiting-shipping {
  background-color: #f2f2f2;
}
.preparing-to-ship {
  background-color: #ffd428;
}
.shipped {
  background-color: #70ad47;
}
.register-processing-error {
  padding: 2px 5px;
  border-radius: 5px;
  color: #ff0000;
  background-color: #fff;
}
.register-processing-inprogress {
  padding: 2px 5px;
  border-radius: 5px;
  color: #a6a6a6;
  background-color: #fff;
}
.judgment-status-not-listed {
  color: #f2f2f2;
  background-color: #a6a6a6;
}
.no-data {
  background-color: rgb(242, 222, 222);
}
.w-280 {
  width: 280px !important;
}
.w-300 {
  width: 300px !important;
}
.w-270 {
  width: 270px !important;
}
.w-210 {
  width: 210px !important;
}
.mx-datepicker {
  width: 100%;
}
#shipping-status-inquiry {
  overflow-y: auto;
}
@media (max-width: 1920px) {
  .table-outter {
    width: 1440px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseAcross/ShippingStatusInquiry.vue